import React from 'react';

import useDispensaryProducts from 'src/dispensary/hooks/use-dispensary-products';
import usePaths from 'src/hooks/use-paths';
import { useBundleProductIds } from 'src/features/bundles/use-bundle-product-ids';
import { ProductCarousel } from 'src/components/carousel-v2/types/product-carousel';
import { useReportCarouselRenderState } from 'src/components/carousels/carousel-render-state';

export function SpecialsCarousel(props) {
  const { loading, products: fetchedProducts } = useDispensaryProducts({
    filters: { isOnSpecial: true, useCache: true },
    perPage: 25,
  });
  const { href } = usePaths({ specials: true });
  const label = props?.title ?? `Items on Sale`;

  // ECOMM-15146: dedupe against BundlesRow -- only excludes when the caller passes
  // excludeProductIds (BundlesRow is actually rendering); `skip` keeps this a true no-op otherwise.
  const { bundleProductIds, loading: bundleProductIdsLoading } = useBundleProductIds({
    skip: !props?.excludeProductIds,
  });
  const isBundledProduct = (product) =>
    bundleProductIds.has(product.id) || bundleProductIds.has(product.enterpriseProductId);
  const products = props?.excludeProductIds
    ? fetchedProducts?.filter((product) => !isBundledProduct(product))
    : fetchedProducts;
  // ECOMM-15146: fold in useBundleProductIds()'s own loading, or excludeProductIds products
  // render then disappear once it resolves.
  const combinedLoading = loading || bundleProductIdsLoading;

  useReportCarouselRenderState({ loading: combinedLoading, hasContent: Boolean(products?.length) });

  if (!products?.length && !combinedLoading) {
    return null;
  }

  return (
    <ProductCarousel
      products={products}
      isLoading={combinedLoading}
      href={href}
      hideTitle={props?.showTitle === false}
      hideLink={props?.showLink === false}
      title={label}
      analyticsSection='Items on Sale'
    />
  );
}
